module.exports = __webpack_public_path__ + "linea-basic-10.61f3a8a387a64abfc053.woff";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-basic-10.woff
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-basic-10.woff
// module chunks = styles